import request from "@/utils/request";
import { apiConfig } from "../config/api";

//请求角色列表
export function getAgentUsers(req) {
  return request({
    url: apiConfig.agentUser.api.searchPager.url,
    method: "post",
    data: {
      username: req.username,
      agentId: req.agentId,
      page: req.page,
      pageSize: req.pageSize
    }
  });
}

//新增角色
export function addAgentUser(user) {
  return request({
    url: apiConfig.agentUser.api.add.url,
    method: "post",
    data: {
      username: user.username,
      agentId: user.agentId
    }
  });
}

//更新角色
export function resetAgentUserPassword(agentUserId) {
  return request({
    url: apiConfig.agentUser.api.resetPassword.url,
    method: "post",
    params: {
      agentUserId: agentUserId
    }
  });
}

//更新角色
export function viewAgentUserPassword(agentUserId) {
  return request({
    url: apiConfig.agentUser.api.viewPassword.url,
    method: "get",
    params: {
      agentUserId: agentUserId
    }
  });
}

//删除角色
export function deleteAgentUser(agentUserId) {
  return request({
    url: apiConfig.agentUser.api.delete.url,
    method: "post",
    params: {
      agentUserId: agentUserId
    }
  });
}

//通过角色编号查询资源
export function findAgentUserResources(agentUserId) {
  return request({
    url: apiConfig.agentUser.api.upresource.url.rel,
    method: "get",
    params: {
      agentUserId: agentUserId,
      resourceTypeCode: "operator"
    }
  });
}

//更新角色与资源之间的关联
export function updateAgentUserResources(agentUserId, resources) {
  return request({
    url: apiConfig.agentUser.api.upresource.url.auth,
    method: "post",
    data: {
      agentUserId: agentUserId,
      resources: resources
    }
  });
}

//通过用户id查询资源
export function findAgentUserProjects(agentUserId) {
  return request({
    url: apiConfig.agentUser.api.upproject.url.rel,
    method: "get",
    params: {
      agentUserId: agentUserId,
      resourceTypeCode: "operator"
    }
  });
}

//更新用户与项目之间的关联
export function updateAgentUserProjects(agentUserId, projects) {
  return request({
    url: apiConfig.agentUser.api.upproject.url.auth,
    method: "post",
    data: {
      agentUserId: agentUserId,
      projects: projects
    }
  });
}

//请求项目树
export function getAgentUserProjects(agentUserId) {
  return request({
    url: apiConfig.agentUser.api.upproject.url.tree,
    method: "get",
    params: {
      agentUserId: agentUserId
    }
  });
}

//请求数据权限列表
export function getDataPermissionList(agentUserId) {
  return request({
    url: apiConfig.agentUser.api.dataPermission.url.list,
    method: "get",
    params: {
      agentUserId: agentUserId
    }
  });
}

//更新用户数据权限
export function updateDataPermission(agentUserId, agentIds) {
  return request({
    url: apiConfig.agentUser.api.dataPermission.url.update,
    method: "post",
    params: {
      agentUserId: agentUserId
    },
    data: agentIds
  });
}
